<template>
  <div class="p-grid p-fluid" style="">
    <div class="p-col-12">
          <label  style='color: red;'><span>*</span> Campos Obrigatórios</label>
    </div>
    <Rotulo nome="Nome:" cols="12" :requerido="true">
      <InputText type="text" v-model="cData.pessoa.nomePessoa" placeholder="Nome" :disabled="!isPodeEditarDados" />
    </Rotulo>
    <Rotulo nome="E-mail:" cols="12 6" :requerido="true">
      <InputText type="text" v-model="cData.pessoa.descEmail" placeholder="E-mail" :disabled="!isPodeEditarDados" />
    </Rotulo>
    <Rotulo nome="Login:" cols="12 6" :requerido="true">
      <InputText type="text" v-model="cData.login" placeholder="Login" :disabled="!isPodeEditarDados" />
    </Rotulo>
    <Rotulo nome="CPF:" cols="12 6" :requerido="true">
      <InputMask
        v-model="cData.pessoa.numrCpf"
        mask="999.999.999-99"
        placeholder="999.999.999-99"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Data de nascimento:" cols="12 6" :requerido="true">
      <InputMask
        v-model="cData.pessoa.dataNascimento"
        mask="99/99/9999"
        placeholder="99/99/9999"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Sexo:" cols="12 6" :requerido="true">
      <SelectButton
        v-model="cData.pessoa.flagSexo"
        :options="paymentOptions"
        optionLabel="name"
        optionValue="value"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Telefone Pessoal:" cols="12 6" :requerido="true">
      <InputMask
        v-model="cData.pessoa.numrTelefonePessoal"
        mask="(99)99999999?9"
        :autoClear="false"
        placeholder="(99)99999-9999"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Telefone Celular: " cols="12 6">
      <InputMask
        v-model="cData.pessoa.numrTelefoneCelular"
        mask="(99)99999999?9"
        :autoClear="false"
        placeholder="(99)99999-9999"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="CEP: " cols="12 6">
      <InputMask
        v-model="cData.pessoa.numrCep"
        mask="99999-999"
        :autoClear="false"
        placeholder="99999-999"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Tipo Logradouro:" cols="12 6">
      <InputText
        type="text"
        v-model="cData.pessoa.endrTipoLogradouro"
        placeholder="Tipo Logradouro"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Logradouro:" cols="12 6">
      <InputText
        type="text"
        v-model="cData.pessoa.endrLogradouro"
        placeholder="Logradouro"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Número:" cols="4 ">
      <InputText type="text" v-model="cData.pessoa.endrNumero" placeholder="Número" :disabled="!isPodeEditarDados" />
    </Rotulo>
    <Rotulo nome="Complemento:" cols="4 ">
      <InputText
        type="text"
        v-model="cData.pessoa.endrComplemento"
        placeholder="Complemento"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo nome="Bairro:" cols="4 ">
      <InputText type="text" v-model="cData.pessoa.endrBairro" placeholder="Bairro" :disabled="!isPodeEditarDados"/>
    </Rotulo>

    <Rotulo nome="Estado:" cols="12 6">
      <Dropdown
        v-model="cData.pessoa.ufRg"
        :options="estados"
        optionLabel="nomeUf"
        placeholder="Selecione uma Estado"
        @change='selecionaCidadePorEstado()'
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <Rotulo v-if='cidades.length>0' nome="Cidade:" cols="12 6">
      <Dropdown
        v-model="cData.pessoa.cidadeEnd"
        :options="cidades"
        optionLabel="nomeCidade"
        placeholder="Selecione uma Cidade"
        :disabled="!isPodeEditarDados"
      />
    </Rotulo>
    <div  style="width: 100%;  border: 1px solid white" v-if="!cData.pessoa.idenPessoa">
      <div class="p-col-12 p-md-4" style="float:right">
      <Button
        label="Salvar"
        class="p-button-success"
        icon="pi pi-check"
        style="margin-top:1rem; "
        @click="cadastrarUsuario()" 
        :disabled="false"
        
      />
      </div>
      
    </div>
    <div  style="width: 100%;  border: 1px solid white" v-else-if="cData.pessoa.flagOrigem=='DECLARACAOBENS'">
      <div class="p-col-4 p-md-4" >
        <Button
          label="Salvar"
          class="p-button-warning"
          icon="pi pi-user-edit"
          @click="atualizarUsuario()"
        />
      </div>
    </div>  
  </div>
</template>
<script>
import Rotulo from "@/template/RotuloSeplag.vue";
import { printToast } from "@/config/global";
import { baseApiUrl } from "@/config/global";
export default {
  name: 'usuario-dados',
  components: { Rotulo },
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    cData: {
      get: function() {
        return this.data
      },
      set: function(val) {
        this.$emit('atualizarDadosCad', val)
      }
    }
  },
  data: function () {
    return {
      paymentOptions: [
        { name: "Masculino", value: "M" },
        { name: "Feminino", value: "F" },
      ],
      estados: [],
      estado: null,
      cidades: [],
      
      isPodeEditarDados : true,
      items: [{
                label: 'Personal',
                to: '/steps'
            },
            {
                label: 'Seat',
                to: '/steps/seat'
            },
            {
                label: 'Payment',
                to: '/steps/payment'
            },
            {
                label: 'Confirmation',
                to: '/steps/confirmation'
            }]
    };
  },
  methods: {
    carregarDados() {
      this.isPodeEditarDados =  this.cData.pessoa.flagOrigem == 'DECLARACAOBENS';
      this.$http.get(`${baseApiUrl}/ufs/all`).then((res) => {
        this.estados = res.data;
      });
    
      if(this.cData.pessoa.ufRg){
          this.$http.get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.cData.pessoa.ufRg.idenUf}`).then((res) => {
          this.cidades = res.data;});
      }
    },
    cadastrarUsuario() {
      let jsonPost = {...this.cData};
      jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace( "(", "" );
      jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace(")", "" );
      jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace("-", "" );
      jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace("(", "" );
      jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace(")", "" );
      jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace("-", "" );
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace("-", "");
      let envio = { 
        ativoConta : jsonPost.ativoConta,
        nomeApresentacao : jsonPost.nomeApresentacao,
        login : jsonPost.login,
        trocarSenha: jsonPost.trocarSenha,
        pessoa:{
            nomePessoa : jsonPost.pessoa.nomePessoa,
            numrCpf: jsonPost.pessoa.numrCpf,
            dataNascimento : jsonPost.pessoa.dataNascimento,
            flagSexo : jsonPost.pessoa.flagSexo,
            descEmail : jsonPost.pessoa.descEmail,
            numrTelefonePessoal : jsonPost.pessoa.numrTelefonePessoal,
            numrTelefoneComercial : jsonPost.pessoa.numrTelefoneComercial,
            numrTelefoneCelular : jsonPost.pessoa.numrTelefoneCelular,
            endrTipoLogradouro : jsonPost.pessoa.endrTipoLogradouro,
            endrLogradouro : jsonPost.pessoa.endrLogradouro,
            endrBairro : jsonPost.pessoa.endrBairro,
            endrComplemento : jsonPost.pessoa.endrComplemento,
            numrCep: jsonPost.pessoa.numrCep,
            endrNumero: jsonPost.pessoa.endrNumero,
            cidadeEnd:jsonPost.pessoa.cidadeEnd,
            ufRg:jsonPost.pessoa.ufRg,
            statPessoa: jsonPost.pessoa.statPessoa,
            flagOrigem : jsonPost.pessoa.flagOrigem,
            flagServidor : jsonPost.pessoa.flagServidor
        }
      }
      
      this.$http
        .post(`${baseApiUrl}/seguranca/contasacesso`, JSON.stringify(envio))
        .then((res) => {
            printToast({severity: 'success', summary: 'Sucesso', detail: 'Cadastrado com sucesso'})
            this.cData = res.data

            this.carregarDados()
        });
    },
    atualizarUsuario() {
      let jsonPost = {...this.cData};
      jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace( "(", "" );
      jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace(")", "" );
      jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace("-", "" );
      jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace("(", "" );
      jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace(")", "" );
      jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace("-", "" );
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
      jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace("-", "");
      let atualizando = { 
        ativoConta : jsonPost.ativoConta,
        nomeApresentacao : jsonPost.nomeApresentacao,
        login : jsonPost.login,
        trocarSenha: jsonPost.trocarSenha,
        pessoa: jsonPost.pessoa       
      }
      this.$http
        .put(`${baseApiUrl}/seguranca/contasacesso/${this.cData.id}`, JSON.stringify(atualizando))
        .then((res) => {
            printToast({severity: 'success', summary: 'Sucesso', detail: 'atualizado com sucesso'})
            this.cData = res.data
            //this.carregarDados()
            
        });

        
    },
    selecionaCidadePorEstado(){
      this.$http.get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.data.pessoa.ufRg.idenUf}`).then((res) => {
        this.cidades = res.data;
        });
      }
  },
  mounted() {
    this.carregarDados();
  },
};
</script>
<style scoped>
    .hr-modal{            
        border: 0;
        height: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        width:100%;
        margin-bottom: 0.7%;
        margin-top: 0.7%;
    }
  
    .estilo-card>.div{
        border-radius: 25px;

    }
 
    @media screen and (max-width: 40em) {
        .padding-coluna{
            padding: 0 !important;
        }            
    }

    .voltar{
        width: auto;
        margin: 0.9rem 0;
    }

    .descricao{
        margin-bottom: 1.5%;
    }
</style>